import store from '../../store'
import router from '../../router'
import _ from 'lodash'
import { Dialog, Notify, Platform } from 'quasar'
import { _removeNoteHelper, allNoteHelpers, findNoteHelper, createNewNote } from './noteHelpers'
import uuid from 'uuid'
import firestore from '../../store/firestore'
import Vue from 'vue'
import { findAllComponentsWithType, getAllComponentInstances } from '../customMdParse/components'
import ch from '../customMdParse/componentHelper'

export class NoteHelper {
  /**
   * Synchronous constructor.  Sets up the note with the passed parameter
   * as an unprocessedNote.
   * @param firestoreNoteObj
   */
  constructor (firestoreNoteObj) {
    this.store = store
    this.router = router
    if (firestoreNoteObj.id === undefined || firestoreNoteObj.data === undefined) {
      throw new Error('Invalid note object passed in constructor.')
    }
    this.unprocessedNote = firestoreNoteObj
    this.noteId = firestoreNoteObj.id
    this._note = null
    this.listeners = {}
    this.formattedTreeItem = null
    // this.configureEditor = this.configureEditor.bind(this)
  }

  static get userSession () {
    const sessionIndex = parseInt(sessionStorage.getItem('userSessionIndex') || 0)
    return store.state.auth.currentUser.sessions[sessionIndex] || {}
  }

  static get sessionRootNote () {
    return findNoteHelper(NoteHelper.userSession.rootNoteId)
  }

  findAllComponentsWithType (componentType) {
    return findAllComponentsWithType(componentType)
  }

  defaultEditorConfig () {
    let splits = Platform.is.mobile
      ? {
        userdata: { visible: false, index: 0, icon: 'mdi-code-braces', locked: false, name: 'User Data', content: 'editor' },
        data: { visible: false, index: 1, icon: 'mdi-markdown', locked: false, name: 'Data', content: 'editor' },
        preview: { visible: true, index: 2, icon: 'far fa-newspaper', locked: false, name: 'Preview', content: 'preview' }
      }
      : {
        userdata: { visible: false, index: 0, icon: 'mdi-code-braces', locked: false, name: 'User Data', content: 'editor' },
        data: { visible: true, index: 1, icon: 'mdi-markdown', locked: false, name: 'Data', content: 'editor' },
        preview: { visible: true, index: 2, icon: 'far fa-newspaper', locked: false, name: 'Preview', content: 'preview' }
      }

    return {
      splits: splits,
      buttons: [
        {
          name: 'Insert Image',
          icon: 'image',
          callback: 'insertImage',
          vm: 'editor'
        },
        {
          name: 'Extract to Sub-Note',
          icon: 'mdi-lightbulb-on-outline',
          // icon: 'mdi-thought-bubble-outline',
          callback: 'extractToSubnote',
          vm: 'editor'
        },
        {
          name: 'New Scratch Note',
          icon: 'mdi-file-document-outline',
          // icon: 'mdi-thought-bubble-outline',
          callback: 'newScratchNote',
          vm: 'editor'
        },
        {
          name: 'Remember This',
          icon: 'mdi-alarm-plus',
          // icon: 'mdi-thought-bubble-outline',
          callback: 'rememberThis',
          vm: 'editor'
        },
        {
          name: 'Switch Layout Orientation',
          icon: function () { return 'border_' + this.layoutOrientation },
          callback: 'switchOrientation',
          vm: 'editor'
        },
        {
          name: 'Settings',
          icon: 'settings',
          callback: 'showEditorSettings',
          vm: 'editor'
        },
        {
          name: 'Publish',
          icon: function () { return this.noteHelper.isPublished ? 'mdi-link-variant' : 'publish' },
          callback: 'publish',
          vm: 'editor'
        }
        // {
        //   name: 'Test',
        //   icon: 'help',
        //   callback: () => {
        //     let addMessage = firestore.functions().httpsCallable('helloWorld')
        //     console.log('Start')
        //     let startTime = new Date()
        //     addMessage({itemId: '5ZUuin6l4ml6FR6UYN8i'}).then((result) => {
        //       // Read result of the Cloud Function.
        //       let n = new Date()
        //       let t = n - startTime
        //       console.log('Took: ' + t)
        //       console.log(result)
        //     })
        //   },
        //   vm: 'editor'
        // },
        // {
        //   name: 'Test1',
        //   icon: 'person',
        //   callback: () => {
        //     let publishComponent = firestore.functions().httpsCallable('publishComponent')
        //     console.log('Start')
        //     let startTime = new Date()
        //     publishComponent({componentId: '5ru4DyhiygCXRVtTX3HX'}).then((result) => {
        //       // Read result of the Cloud Function.
        //       let n = new Date()
        //       let t = n - startTime
        //       console.log('Took: ' + t)
        //       console.log(result)
        //     })
        //   },
        //   vm: 'editor'
        // },
        // {
        //   name: 'Test2',
        //   icon: 'edit',
        //   callback: () => {
        //     let setUsername = firestore.functions().httpsCallable('setUsername')
        //     console.log('Start')
        //     let startTime = new Date()
        //     setUsername('mattyc').then((result) => {
        //       // Read result of the Cloud Function.
        //       let n = new Date()
        //       let t = n - startTime
        //       console.log('Took: ' + t)
        //       console.log(result)
        //     })
        //   },
        //   vm: 'editor'
        // }
      ]
    }
  }

  /**
   * Make a copy of this note.
   * If parentNoteHelperOrId is null or undefined, make a copy under the same parent
   * If parentNoteHelperOrId is a String, make a copy under that note
   * If parentNoteHelperOrId is a NoteHelper, make a copy under that note
   * @param parentNoteHelperOrId {NoteHelper|String|null|undefined}
   * @param copyChildren {boolean} If true, copy children as well
   */
  copyTo (parentNoteHelperOrId, copyChildren) {
    let newItem = {
      data: this.note.data,
      userData: this.note.userData,
      children: []
    }
    let parentId = this.parent.noteId
    if (parentNoteHelperOrId instanceof NoteHelper) {
      parentId = parentNoteHelperOrId.noteId
    } else if (parentNoteHelperOrId instanceof String) {
      if (findNoteHelper(parentNoteHelperOrId) === undefined) {
        throw new Error('Parent does not exist')
      }
      parentId = parentNoteHelperOrId
    }
    return createNewNote(newItem, parentId).then((newNoteHelper) => {
      let promises = []
      if (!copyChildren) return newNoteHelper
      this.note.children.forEach((id) => {
        let helper = findNoteHelper(id)
        if (helper === undefined) {
          throw new Error('Parent does not exist when copying child')
        }
        promises.push(helper.copyTo(newNoteHelper, true))
      })
      return Promise.all(promises).then(() => {
        return newNoteHelper
      })
    })
  }

  get name () {
    if (this.formattedTreeItem) return this.formattedTreeItem.label
    return this.getFormattedTreeItem().label
  }

  /**
   * Returns true if the note has been published, false if not
   * Does not check that the published note actually exists, just
   * tells you if userData.publicId equates to true.
   * @returns {boolean}
   */
  get isPublished () {
    if (!('publishedIds' in this.note)) return false
    if (typeof this.note.publishedIds !== 'object') return false
    if (this.note.publishedIds.constructor !== Array) return false
    return this.note.publishedIds.length
  }

  // get publishedId () {
  //   return this.note.publishedId
  // }

  getUsedComponentIds () {
    // Only works when the note is rendered
    let unpublishedNames = [] // Components mush be published to be rendered in public notes
    let componentIds = []
    let componentInstances = getAllComponentInstances()
    componentInstances.forEach(componentInstance => {
      if (!componentInstance.cmpDef._raw.publishedId) {
        unpublishedNames.push(componentInstance.cmpDef.type)
        return
      }
      componentIds.push(componentInstance.cmpDef._raw.publishedId)
    })

    if (unpublishedNames.length) {
      let unpubNamesStr = ''
      _.uniq(unpublishedNames).forEach(name => {
        unpubNamesStr += name + ', '
      })
      unpubNamesStr = unpubNamesStr.slice(0, -2)
      return this.dialog({
        title: 'Publish',
        message: 'The following components are contained in the note but are not published: ' +
          unpubNamesStr +
          '.  These components will not be visible in the published note.  Are you sure you want ' +
          'to publish this note now?',
        ok: true,
        cancel: true
      }).then(() => {
        return Promise.resolve(componentIds)
      })
    }

    return Promise.resolve(componentIds)
  }

  /**
   * Publishes a note.
   */
  publish () {
    return this.getUsedComponentIds().then((compIds) => {
      return firestore.functions().httpsCallable('publishNote')({
        noteId: this.note.id,
        components: compIds,
        storageURLs: _.map(window.$ch._storageURLs, 'filename')
      })
    })
    //
    // let vm = this
    // let publicNote = Object.assign({}, this.note)
    // delete publicNote['id']
    // delete publicNote['updatedAt']
    // delete publicNote['createdAt']
    // delete publicNote['children']
    // publicNote.publishedAt = new Date()
    // publicNote.publisherId = this.store.state.auth.currentUser.uid
    //
    // publicNote['components'] = this.getUsedComponentIds()
    //
    // let ref = firestore.db.collection('publicNotes').doc()
    // return ref.set(publicNote).then(() => {
    //   Vue.set(vm._note, 'publishedId', ref.id)
    //   vm.save()
    //   return ref.id
    // })
  }

  unpublish () {
    if (!this.isPublished) return
    let vm = this
    let ref = firestore.db.collection('publicNotes').doc(this.publishedId)
    return ref.delete().then(() => {
      Vue.delete(vm._note, 'publishedId')
      vm.save()
      return ref.id
    })
  }

  /**
   * Gets child note helpers
   * @param all   if true, get direct children, if false get all children recursively
   * @returns {*}
   */
  children (all = false) {
    let immediateChildren = this.note.children.map(noteId => findNoteHelper(noteId))
    if (!all) return immediateChildren

    let allChildren = []
    immediateChildren.forEach((child) => {
      if (!child) return
      allChildren.push(child)
      allChildren = allChildren.concat(child.children(true))
    })
    return allChildren
  }

  /**
   * Resets the note back to what it was when it was last retrieved from the server or saved.
   * @public
   * @name reset
   * @ternType fn() -> Promise()
   * @ternDoc Resets the note back to what it was when it was last retrieved from the server or saved.  Returns a promise that resolves when the reset is complete.  Note this does not save any local changes.
   */
  reset () {
    this.noteTemplate = null
    return this.updateFromFirestore(this.unprocessedNote)
  }

  static hasNoteChanged (oldNote, newNote) {
    return !(_.isMatch(oldNote, _.omit(newNote, ['updatedAt'])))
  }

  _updateNoteTemplate () {
    let newNoteTemplate = this._findNoteTemplate()
    if (newNoteTemplate === this.noteTemplate) return
    this.noteTemplate = newNoteTemplate
    if (newNoteTemplate == null) return
    this.noteTemplateInst = this._createNoteTemplateLocalInstance()
  }

  addNoteToChildren (noteId, index = '-1') {
    if (!this.note.children) {
      this.note.children = []
    }
    if (index < 0 || index > this.note.children.length) {
      this.note.children.push(noteId)
    } else {
      this.note.children.splice(index, 0, noteId)
    }
    return this.save()
  }

  /**
   * Returns the parent note helper of this note.
   * Returns null if the note is a root note.
   * Returns undefined if the note is orphaned.
   * @returns {NoteHelper|null|undefined}
   */
  get parent () {
    let parent
    allNoteHelpers().some((noteHelper) => {
      if (!('children' in (noteHelper.note || {}))) return false
      if (noteHelper.note.children.indexOf(this.noteId) === -1) return false
      parent = noteHelper
      return true
    })
    if (parent) return parent

    if (store.getters.rootNoteIds.indexOf(this.noteId)) return null

    return undefined
  }

  /**
   * Set to either a NoteHelper or the new parent note id.
   * Set to null to make it a root note.
   * Set to undefined to make it an orphaned note.
   * @param parentNoteHelperOrId {NoteHelper|null|undefined}
   */
  set parent (parentNoteHelperOrId) {
    this.setParent(parentNoteHelperOrId)
  }

  /**
   * Set to either a NoteHelper or the new parent note id.
   * Set to null to make it a root note.
   * Set to undefined to make it an orphaned note.
   * @param parentNoteHelperOrId {NoteHelper|null|undefined}
   * @param newIndex {int} the index within the parent that the item should be placed
   */
  setParent (parentNoteHelperOrId, newIndex = -1) {
    const promises = []
    const oldParent = this.parent
    let newParentId
    if (parentNoteHelperOrId instanceof NoteHelper) newParentId = parentNoteHelperOrId.noteId
    else if (typeof parentNoteHelperOrId === 'string') newParentId = parentNoteHelperOrId
    else if (parentNoteHelperOrId === null || parentNoteHelperOrId === undefined) newParentId = parentNoteHelperOrId
    else throw new Error('Could not set parent, invalid value passed.')

    // If we didn't pass an index and the oldParent == newParent then there's nothing to do.  Exit.
    if (((oldParent || {}).noteId || oldParent) === newParentId && newIndex === -1) return Promise.resolve(null)
    if (newParentId === this.noteId) throw new Error('Cannot set note parent to itself.')
    // TODO: Don't let the user move this note to a child of iteslf!!!

    if (!((oldParent || {}).noteId || oldParent) && newParentId === null) {
      // Just moving a root note
      let newRootChildIds = store.getters.rootNoteIds.slice(0)
      let index = newRootChildIds.indexOf(this.noteId)
      newRootChildIds.splice(index, 1)
      newRootChildIds.splice(newIndex, 0, this.noteId)
      promises.push(store.dispatch('updateRootChildren', newRootChildIds))
      console.log('move root note')
      return Promise.all(promises)
    }

    if (oldParent) {
      let index = oldParent.note.children.indexOf(this.noteId)
      if (index >= 0) oldParent.note.children.splice(index, 1)
      const indexInTreeItem = oldParent.formattedTreeItem.children.findIndex(item => item.id === this.noteId)
      if (indexInTreeItem >= 0) {
        Vue.delete(oldParent.formattedTreeItem.children, indexInTreeItem)
      }
      promises.push(oldParent.save())
    } else if (oldParent === null) {
      let index = store.getters.rootNoteIds.indexOf(this.noteId)
      let newRootChildIds = store.getters.rootNoteIds.slice(0)
      console.log('indexaa:', index)
      newRootChildIds.splice(index, 1)
      promises.push(store.dispatch('updateRootChildren', newRootChildIds))
    }

    if (newParentId === undefined) {
      // Note should be orphaned.  Just return.
    } else if (newParentId === null) {
      promises.push(store.dispatch('addRootChild', { childId: this.noteId, index: newIndex }))
    } else {
      let newParentHelper = findNoteHelper(newParentId)
      if (!newParentHelper) throw new Error('Could not set parent, could not find new parent note helper.')
      promises.push(newParentHelper.addNoteToChildren(this.noteId, newIndex))
      newParentHelper.formattedTreeItem.children.push(this.getFormattedTreeItem())
    }

    return Promise.all(promises)
  }

  /**
   * Pushes a new note to firestore
   * @param noteData  {*} must have id property set
   */
  newNoteToFirestore (noteData) {
    this._updateNoteTemplate()
    this._note = noteData
    store.commit('setItem', noteData)
    return this.save()
  }

  /**
   * @param firestoreNoteObj  {*}     The updated note
   * @param source            string  'Server' or 'Local'
   */
  updateFromFirestore (firestoreNoteObj, source) {
    if (!source) source = 'Server'
    this.unprocessedNote = firestoreNoteObj
    this._updateNoteTemplate()
    return this._decode(firestoreNoteObj).then(processedNote => {
      if (!processedNote) processedNote = null
      if (processedNote == null) return
      console.log('changed?', !NoteHelper.hasNoteChanged(this._note, processedNote))
      // if (!NoteHelper.hasNoteChanged(this._note, processedNote)) return
      if (source === 'Server') {
        this._emitEvent('change', processedNote)
      }
      this._note = processedNote
      this.store.commit('setItem', this.note)
    })
  }

  /**
   * Refreshes the active editor if this note is visible calling configureEditor again to fetch the editor config.
   * @public
   * @name refreshEditor
   * @ternType fn()
   * @ternDoc Refreshes the active editor if this note is visible calling configureEditor again to fetch the editor config.
   */
  refreshEditor () {
    // TODO: should this return a promise?
    if (!this._hasListenerForEvent('refreshEditor')) return
    this.configureEditor().then(config => {
      this._emitEvent('refreshEditor', config)
    })
  }

  /**
   * Adds an event listener
   * @public
   * @name refreshEditor
   * @ternType fn(eventName: string, callback: fn(data: {})) -> fn()
   * @ternDoc Refreshes the active editor if this note is visible calling configureEditor again to fetch the editor config.
   */
  addEventListener (eventName, callback) {
    if (!(eventName in this.listeners)) {
      this.listeners[eventName] = []
    }
    if (!(typeof callback === 'function')) throw new Error('callback must be a function.')
    this.listeners[eventName].push(callback)
    let t = this
    let stopListeningCallback = function () {
      let index = (t.listeners[eventName] || []).indexOf(callback)
      if (index > -1) {
        t.listeners[eventName].splice(index, 1)
      }
    }
    return stopListeningCallback
  }

  _hasListenerForEvent (eventName) {
    return ((eventName in this.listeners) && this.listeners[eventName].length > 0)
  }

  _emitEvent (eventName, data) {
    if (!(eventName in this.listeners)) return
    this.listeners[eventName].forEach(listener => {
      listener(data)
    })
  }

  // get allNotes () {
  //   return store.state.items.items
  // }

  /**
   * Gets the current note (ie reactive Vuex object).
   * Note: When updated from firestore the note will change and all
   *       previous references retrieved through this function will
   *       be broken.  To remedy, listen to onChange event and assign
   *       the reference to the parameter.  eg.
   *       var noteRef = helper.note
   *       onChangeCallback (data) { noteRef = data }
   *       helper.addEventListener('change', onChangeCallback)
   * @returns {null|*}
   */
  get note () {
    return this._note
  }

  _createNoteTemplateLocalInstance () {
    if (!(this.noteTemplate)) return null
    try {
      let noteTemplateHelperInst = new this.noteTemplate.UserClass()
      noteTemplateHelperInst.helper = this
      Object.defineProperty(noteTemplateHelperInst, 'note', {
        get: () => this.note
      })
      return noteTemplateHelperInst
    } catch (ex) {
      return null
    }
  }

  _findNoteTemplate () {
    if (!(this._getNoteTemplateId())) return null
    return store.getters.findNoteTemplate(this._getNoteTemplateId())
  }

  _getNoteTemplateId () {
    return (this.unprocessedNote.userData || {}).templateId
  }

  _hasUserClassFunction (funcName) {
    if (!(this.noteTemplate)) return false
    if (!(this.noteTemplate.UserClass)) return false
    if (!(this.noteTemplate.UserClass.prototype)) return false
    if (!(funcName in this.noteTemplate.UserClass.prototype)) return false
    if (typeof this.noteTemplate.UserClass.prototype[funcName] !== 'function') return false
    if (!this.noteTemplateInst) return false
    return true
  }

  /**
   * Saves the note
   * @return a promise that resolves to a boolean specifying whether the note template has changed
   */
  save () {
    console.log('Saving item ' + this.note.id)
    console.log(this)
    this.note.updatedAt = new Date()
    let vm = this
    const newTemplateId = vm.note.userData.templateId
    const oldTemplateId = vm._getNoteTemplateId()
    const oldUnprocessedNote = vm.unprocessedNote
    return vm._encode(Object.assign({}, this.note)).then(encodedNote => {
      if (!encodedNote) {
        console.warn('Could not save item ' + vm.note.id)
        return
      }
      if (oldTemplateId !== newTemplateId) {
        // vm.noteTemplate = null
        // vm.reset()
        // vm._updateNoteTemplate()
        vm.updateFromFirestore(encodedNote, 'Server')
        vm.refreshEditor()
      }
      vm.unprocessedNote = encodedNote
      vm.store.dispatch('updateItem', encodedNote).then(() => {
        vm.updateFormattedTreeItem(vm._getFormattedTreeItem())
        // console.log('old: ' + vm._getNoteTemplateId() + ' !== ' + 'new: ' + newTemplateId)
      }).catch((e) => {
        vm.unprocessedNote = oldUnprocessedNote
        console.log(console.warn('Could not save item to firestore' + vm.note.id + e))
      })
      return Promise.resolve(oldTemplateId !== newTemplateId)
    })
  }

  updateFormattedTreeItem (updates) {
    if (!this.formattedTreeItem) return
    // for (const [key, value] in Object.entries(updates)) {
    //   if (key in this.formattedTreeItem &&
    //     this.formattedTreeItem[key] !== value) {
    Object.assign(this.formattedTreeItem, updates)
    //     return
    //   }
    // }
  }

  getFormattedTreeItem () {
    this.formattedTreeItem = this._getFormattedTreeItem()
    return this.formattedTreeItem
  }

  _getFormattedTreeItem () {
    try {
      let treeItem = this._getUnprocessedFormattedTreeItem()
      if (!('label' in treeItem)) treeItem.label = ch.getItemName(this.note)
      if (!('id' in treeItem)) treeItem.id = this.noteId
      return treeItem
    } catch (ex) {
      console.warn(ex)
      return { icon: 'error', iconColor: 'red', label: ex.message }
    }
  }

  _getUnprocessedFormattedTreeItem () {
    if (!this._hasUserClassFunction('formatTreeItem')) return {}
    return this.noteTemplateInst.formatTreeItem()
  }

  _notifyError (functionName, ex) {
    console.error('Error in ' + functionName + ' of ' + this.noteId)
    console.error(ex)
    return this.notify({
      message: 'Error in ' + functionName + ' of ' + this.noteId,
      type: 'negative',
      position: 'bottom',
      actions: [
        {
          label: 'debug (ctrl-shift-J)',
          icon: 'mdi-bug',
          handler: () => {
            // modalFn(DebugModal, {ex: ex}) // .show(ex)
            this.dialog({
              title: 'Error',
              message: 'Press ctrl-shift-J to show the error in your browser\'s debugging tools.', // ex.stack,
              ok: true,
              cancel: false
            })
          }
        }
      ]
    })
  }

  _encode (noteClone) {
    if (!this._hasUserClassFunction('encode')) return Promise.resolve(Object.assign({}, this.note))
    try {
      return Promise.resolve(this.noteTemplateInst.encode(noteClone)).then(encodedVal => {
        if (!encodedVal) throw new Error('encode must return an encoded note.')
        return encodedVal
      })
    } catch (ex) {
      this._notifyError('encode', ex)
      return Promise.resolve(null)
    }
  }

  async _decode () {
    if (!this._hasUserClassFunction('decode')) return Promise.resolve(Object.assign({}, this.unprocessedNote))
    try {
      const result = await Promise.resolve(this.noteTemplateInst.decode(Object.assign({}, this.unprocessedNote))) // Must modify this.note in place!
      if (!result) throw Error(`Unable to decode note ${this.noteid} with template ${this.noteTemplate.name}`)
      return result
    } catch (ex) {
      this._notifyError('decode', ex)
      return Promise.resolve(this.unprocessedNote)
    }
  }

  // Called when the note is accessed
  onAccess () {
    if (!this._hasUserClassFunction('onAccess')) return Promise.resolve(this.note)
    try {
      return Promise.resolve(this.noteTemplateInst.onAccess()) // Must modify this.note in place!
    } catch (ex) {
      this._notifyError('onAccess', ex)
      return Promise.resolve(this.note)
    }
  }

  configureEditor () {
    let defaultConfig = this.defaultEditorConfig()
    if (!this._hasUserClassFunction('configureEditor')) return Promise.resolve(defaultConfig)
    try {
      return Promise.resolve(this.noteTemplateInst.configureEditor(defaultConfig))
    } catch (ex) {
      this._notifyError('configureEditor', ex)
      return Promise.resolve(defaultConfig)
    }
  }

  destroy () {
    _removeNoteHelper(this.noteId)
  }

  dialog (configObj) {
    return Dialog.create(configObj)
  }

  notify (configObj) {
    return Notify.create(configObj)
  }

  /**
   * Generates a UUID
   * @param dashes  boolean if true result like 'abcd-1234-aabb', if false result like 'abcd1234aabb'
   * @param v1      boolean if false generates a v4 (random) uuid, if true generates a v1 (time based) uuid
   * @public
   * @name generateUUID
   * @ternType fn(removeDashesv1: boolean) -> string
   * @ternDoc Generates a UUID.  If v1=false generates a v4 (random) uuid, if v1=true generates a v1 (time based) uuid.
   */
  generateUUID (dashes = false, v1 = false) {
    let v = ''
    if (v1) {
      v = uuid.v1()
    } else {
      v = uuid.v4()
    }
    if (!dashes) v = v.replace(/-/g, '')
    return v
  }
}

export default NoteHelper
